import herdInstinct from "./components/product/herd_instinct";
import initSimilarProducts from "./screens/product/similar_products";
import initTooltips from "./components/tooltips";
import './components/recaptcha';
import { initPhotoPopups } from "./components/photoswipe";
import initAromaVote from "./screens/product/aroma_vote";
import handleAddToCartButtonClick from "./components/product/add_to_cart";
import { addGlobalLiveEventListener } from "./utils";
import initProductOfferApp from "./screens/product/card";
import { makeProductSlider, makeProductThumbsSlider, makeSimilarProductsCarousel, makeTagsSlider } from "./components/slider";
document.addEventListener('DOMContentLoaded', function () {
    var _a;
    initTooltips();
    addGlobalLiveEventListener('click', '.to_basket', function (e) {
        e.preventDefault();
        handleAddToCartButtonClick(parseInt(this.dataset.id));
    });
    (_a = document.querySelector('.click_now')) === null || _a === void 0 ? void 0 : _a.click();
});
const thumbsSlider = makeProductThumbsSlider();
const productSlider = makeProductSlider(thumbsSlider);
productSlider.on('slideChange', () => thumbsSlider.slideTo(productSlider.realIndex - 1));
initProductOfferApp(productSlider, thumbsSlider);
initSimilarProducts();
makeTagsSlider();
makeSimilarProductsCarousel();
initAromaVote();
initPhotoPopups();
herdInstinct(document.querySelector('.prod-msg'));
